export default "__VITE_ASSET__ByS4Dgky__"